/*
 * Quick View for Interia collection pages (templates/collection.liquid).
 * Loads templates/product.interia-quick.liquid into a <dialog> and adds to the Gallery through
 * /cart/add.js behind Shopify.BrandLock, the same guard snippets/ajaxify-cart.liquid applies.
 */
(function () {
  var dialog = document.querySelector('[data-ih-quick-dialog]');
  if (!dialog) return;

  var body = dialog.querySelector('[data-ih-quick-body]');
  var labels = dialog.dataset;
  var opener = null;
  var request = 0;

  function link(href, text) {
    var anchor = document.createElement('a');
    anchor.href = href;
    anchor.textContent = text;
    return anchor;
  }

  function setStatus(text, productUrl) {
    var status = document.createElement('p');
    status.className = 'ih-dialog__status';
    status.textContent = text;
    if (productUrl) status.append(' ', link(productUrl, 'Open the product page'));
    body.replaceChildren(status);
  }

  function showFeedback(feedback, kind, message, withGallery) {
    feedback.className = 'ih-quick__feedback ih-quick__feedback--' + kind;
    feedback.textContent = message;
    if (withGallery) feedback.append(' ', link('/cart', labels.view));
    feedback.hidden = false;
  }

  // Without Shopify.BrandLock the add goes straight through, as in ajaxify-cart.
  function checkBrand(form, done) {
    if (window.Shopify && Shopify.BrandLock) Shopify.BrandLock.check(Shopify.BrandLock.fromElement(form), done);
    else done({ ok: true, brands: [] });
  }

  function bind(product) {
    var stage = product.querySelector('[data-ih-quick-image]');
    var thumbs = product.querySelectorAll('[data-ih-quick-thumb]');

    function showImage(src, thumb) {
      if (!stage || !src) return;
      stage.src = src;
      thumbs.forEach(function (item) { item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false'); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showImage(thumb.getAttribute('data-src'), thumb); });
    });

    var variant = product.querySelector('[data-ih-quick-variant]');
    if (variant) {
      variant.addEventListener('change', function () {
        var option = variant.options[variant.selectedIndex];
        var imageId = option.getAttribute('data-image-id');
        if (!imageId) return;
        showImage(option.getAttribute('data-image'), product.querySelector('[data-ih-quick-thumb][data-image-id="' + imageId + '"]'));
      });
    }

    var form = product.querySelector('[data-ih-quick-form]');
    if (!form) return;
    var button = form.querySelector('[data-ih-quick-add]');
    var feedback = form.querySelector('[data-ih-quick-feedback]');
    var label = button.textContent;
    var busy = false;

    function reset() {
      busy = false;
      button.disabled = false;
      button.textContent = label;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      busy = true;
      button.disabled = true;
      button.textContent = labels.adding;
      feedback.hidden = true;

      checkBrand(form, function (result) {
        if (!result.ok) {
          reset();
          showFeedback(feedback, 'error', result.message, true);
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (data) { return { ok: response.ok, data: data }; });
          })
          .then(function (added) {
            if (!added.ok) {
              reset();
              showFeedback(feedback, 'error', added.data.description || added.data.message || labels.error, false);
              return;
            }
            if (window.InteriaGallery) InteriaGallery.refresh();
            button.textContent = labels.thanks;
            showFeedback(feedback, 'success', labels.added + '.', true);
            // Hold the button for a second, as the product page does, so a double click adds once.
            window.setTimeout(reset, 1000);
          })
          .catch(function () {
            reset();
            showFeedback(feedback, 'error', labels.error, false);
          });
      });
    });
  }

  function open(url, trigger) {
    var current = ++request;
    opener = trigger;
    setStatus(labels.loading);
    if (!dialog.open) dialog.showModal();

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Quick view returned ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (current !== request) return;
        var product = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ih-quick-product]');
        if (!product) throw new Error('Unexpected quick view response');
        body.replaceChildren(product);
        bind(product);
      })
      .catch(function () {
        if (current !== request) return;
        setStatus(labels.failed, url.split('?')[0]);
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ih-quick]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger.getAttribute('data-ih-quick'), trigger);
  });

  dialog.querySelector('[data-ih-quick-close]').addEventListener('click', function () { dialog.close(); });
  // A click on the backdrop lands on the dialog element itself, outside the panel.
  dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', function () {
    request++;
    body.replaceChildren();
    if (opener) opener.focus();
  });
})();
